import FinanceStatistics from "../../../finance/components/FinanceStatistic";
import VehicleFinanceCard from "../../../finance/components/VehicleFinanceCard";
import VehicleFinanceCard02 from "../../../finance/components/VehicleFinanceCard02";
import VehicleIncomeAndExpense from "../../../finance/components/VehicleIncomeAndExpense";
import { Vehicle } from "../../@types";

interface FinanceTabProps {
  id: string;
  idType: string;
  vehicle?: Vehicle;
}

const FinanceTab: React.FC<FinanceTabProps> = ({ id, vehicle, idType }) => {
  const section = idType === "vehicle" ? `vehicle/${id}` : `driver/${id}`;

  return (
    <div className="space-y-4">
      {vehicle ? (
        <VehicleFinanceCard02 vehicle={vehicle} />
      ) : (
        <VehicleFinanceCard section={section} />
      )}
      <FinanceStatistics id={id} idType={idType} />
      <VehicleIncomeAndExpense id={id} idType={idType} />
    </div>
  );
};

export default FinanceTab;
